import {
    GET_MANAGER_LEADS_LEAD_MANAGE,
    GET_MANAGER_LEADS_LEAD_MANAGE_SUCCESS,
    GET_MANAGER_LEADS_LEAD_MANAGE_FAILURE,
    COUNT_MANAGER_LEADS_SUCCESS,
    COUNT_MANAGER_LEADS_FAILURE,
    SET_MANAGER_LEAD_MANAGE_LOADING,
    SET_MANAGER_LEAD_MANAGE_KEY,
    UPDATE_MANAGER_LEAD_MANAGE_KEY,
    SET_MANAGER_LEAD_MANAGE_PAGINATION,
    SET_MANAGER_LEAD_MANAGE_NEW_KEY_VALUE,
} from '../constants/get_manager_leads.constants';

import {
    LEAD_MANAGER_CHANGE_LEADS_STATUS_REQUEST,
    LEAD_MANAGER_CHANGE_LEADS_STATUS_SUCCESS,
    LEAD_MANAGER_CHANGE_LEADS_STATUS_FAILURE,
} from '../constants/lead_manage_leads_status.constants';

import {
    setVal, extend, each, get, is,
} from '../../../../../shared/helpers';

const initialState = {
    manager_leads: null,
    loading: false,
    manager_leads_count: 0,
    pagination: {
        page: 1,
        rows_per_page: 100,
    },
    where: {},
    filters: {
        dateFrom: undefined,
        dateTo: undefined,
        marginFrom: undefined,
        marginTo: undefined,
        location: undefined,
    },
};

export const Manager_leads_manage = (state = initialState, action) => {
    switch (action.type) {
    case 'RESET_LEADS':
        return {
            ...state,
            loading: false,
        };
    case SET_MANAGER_LEAD_MANAGE_LOADING:
        setVal(state, 'loading', action.loading);
        return extend({}, state);

    case UPDATE_MANAGER_LEAD_MANAGE_KEY:
        return extend(true, {}, state, action.data);

    case SET_MANAGER_LEAD_MANAGE_NEW_KEY_VALUE:
        let state_changed = false;

        if (is.plainObject(action.data)) {
            each(action.data, (path, value) => {
                if (get(state, path) !== value) {
                    state_changed = true;
                    setVal(state, path, value);
                }
            });
            // return utils.extend( {}, state );
        } else if (is.string(action.path)) {
            if (get(state, action.path) !== action.value) {
                state_changed = true;
                setVal(state, action.path, action.value);
            }
            // return utils.extend( {}, state );
        }

        return state_changed ? { ...state } : state;


    case SET_MANAGER_LEAD_MANAGE_KEY:
        const filterValue = (action.value === '' || action.value === undefined || (typeof action.value === 'number' && isNaN(action.value))) ? undefined : action.value;

        if (action.path && typeof filterValue === 'object') {
            Object.keys(action.value)
                .forEach((key) => {
                    setVal(state, `${action.path}.${key}`, action.value[key]);
                });
        } else {
            setVal(state, action.path, filterValue);
        }
        return extend({}, state);

    case SET_MANAGER_LEAD_MANAGE_PAGINATION:
        const paginationValue = (action.value === '' || action.value === undefined || (typeof action.value === 'number' && isNaN(action.value))) ? undefined : action.value;

        if (action.path && typeof paginationValue === 'object') {
            Object.keys(paginationValue)
                .forEach((key) => {
                    setVal(state, `${action.path}.${key}`, paginationValue[key]);
                });
        } else {
            setVal(state, action.path, paginationValue);
        }
        return extend({}, state);

        //-----------------------------------------------------------------------------
    case GET_MANAGER_LEADS_LEAD_MANAGE:
        return {
            ...state,
            manager_leads: [],
            manager_leads_count: 0,
        };

    case GET_MANAGER_LEADS_LEAD_MANAGE_SUCCESS:
        return {
            ...state,
            manager_leads: action.manager_leads,
        };


    case GET_MANAGER_LEADS_LEAD_MANAGE_FAILURE:
        return {
            ...state,
            error: action.error,
            manager_leads: [],
            manager_leads_count: 0,
        };
        //-----------------------------------------------------------------------------

    case LEAD_MANAGER_CHANGE_LEADS_STATUS_REQUEST:
        return {
            ...state,
            id: '',
            shouldKill: false,
            margin: 0,
        };

    case LEAD_MANAGER_CHANGE_LEADS_STATUS_SUCCESS:
        return {
            ...state,
            id: action.id,
            shouldKill: action.shouldKill,
            margin: action.margin,
        };

    case LEAD_MANAGER_CHANGE_LEADS_STATUS_FAILURE:
        return {
            ...state,
            id: '',
            shouldKill: false,
            margin: 0,
            error: action.error,
        };

    case COUNT_MANAGER_LEADS_SUCCESS:
        return {
            ...state,
            manager_leads_count: action.manager_leads_count,
        };
    case COUNT_MANAGER_LEADS_FAILURE:
        return {
            ...state,
            error: action.error,
            manager_leads_count: 0,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Manager_special/redux/reducers/leads_manage.reducer.js